import React from "react";
import AboutSection from "../Components/AboutSection";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div
        className="h-[16rem] md:h-[20rem] bg-cover relative bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url("./img/about.jpg")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-800/70 to-slate-900/90"></div>
        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-4 tracking-wide">
            About Us
          </h1>
          <p className="text-lg md:text-xl text-slate-100 max-w-3xl mx-auto">
            Your Trusted Partner for Precision Calibration Services
          </p>
        </div>
      </div>

      <AboutSection />

      {/* Mission and Quality Policy */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 mb-4">
              Our Core Values
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Guiding principles that drive our commitment to excellence
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div className="relative overflow-hidden bg-white rounded-3xl shadow-2xl hover:shadow-blue-50/50 transition-all duration-500 hover:-translate-y-1">
              <div className="p-10">
                <div className="flex items-center gap-4 mb-6">
                  <h3 className="text-3xl font-bold text-slate-800">Our Mission</h3>
                </div>
                <p className="text-slate-700 text-lg leading-relaxed">
                  We strive to provide technologically sound and financially viable real-time solutions in the field of Calibration and Instrumentation.
                </p>
              </div>
            </div>
            <div className="relative overflow-hidden bg-white rounded-3xl shadow-2xl hover:shadow-blue-50/50 transition-all duration-500 hover:-translate-y-1">

              <div className="p-10">
                <div className="flex items-center gap-4 mb-6">
                  <h3 className="text-3xl font-bold text-slate-800">Quality Policy</h3>
                </div>
                <p className="text-slate-700 text-lg leading-relaxed">
                  Our goal is to deliver prompt, reliable, and technically sound calibration and testing services that meet customer satisfaction. We strive to project ourselves as a competent and trustworthy laboratory, adhering to professional ethics and ensuring all results are traceable to national and international standards.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="w-[90%] mx-auto my-8 text-justify px-4">
        <p className="text-md text-slate-600 text-justify">
          To better serve your organization's needs, we kindly request the
          entire list of instruments requiring calibration. This will enable us
          to tailor our services and provide you with a competitive quotation
          promptly.
        </p>
      </div>

      {WhyChooseUs()}
    </>
  );
};

export default About;

const WhyChooseUs = () => {
  const features = [
    {
      icon: "🏅",
      title: "Quality",
      description: "100% quality of measurements.",
    },
    {
      icon: "🔧",
      title: "Onsite Calibration",
      description:
        "We have onsite calibration facility of all instruments except dimension instruments.",
    },
    {
      icon: "⏰",
      title: "Cal Reminder",
      description:
        "Email notification and reminder by call when instruments are due for calibration.",
    },
    {
      icon: "🤝",
      title: "Flexibility",
      description:
        "We organise onsite calibration on Sunday in request basis to avoid shutdown of machines in working days.",
    },
    {
      icon: "📧",
      title: "Fast Response",
      description:
        "Our dedicated team always will be ready to assist with customer queries, clarifications, scan copies of certificates, traceability, etc.",
    },
    {
      icon: "⏳",
      title: "Reports Duration",
      description:
        "The calibration certificates will be arranged at your end within a week from the date of completion of calibration work.",
    },
    {
      icon: "💰",
      title: "Competitive Prices",
      description:
        "Offering the best competitive pricing for all calibration services.",
    },
    {
      icon: "📅",
      title: "In-Time Calibration Schedule",
      description: "We ensure timely calibration without delays.",
    },
    {
      icon: "🚚",
      title: "Pick up & Delivery",
      description:
        "FREE Pick up & delivery will be arranged from our end for above 10 instruments.",
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-gray-800">
          Why ADARSH CALIBRATION LLP?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center bg-white p-8 shadow-xl rounded-2xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100"
            >
              <div className="text-6xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-blue-700 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
